import type { SxProps, Theme } from "@mui/material";
import { alpha, useTheme } from "@mui/material";
import { createSxStyles } from "../createSxStyles";
import { getRightIconsStyle, iconSize } from "./iconsContainer";
import { commonInputStyles } from "./inputStyles";
import type { MultiSelectProps } from "./MultiSelect";

export const useMultiSelectStyles = (props: MultiSelectProps) => {
    const theme = useTheme();
    const commonStyles = commonInputStyles(theme, props.variant, false, undefined);
    return createSxStyles({
        root: {
            "&:hover .MuiAutocomplete-popupIndicator": {
                visibility: "visible",
            },
            "& .MuiInput-root": {
                paddingBottom: props.variant === "standard" ? theme.spacing(1) : "inherit",
            },
            "& .MuiAutocomplete-tagSizeSmall": {
                fontSize: theme.typography.pxToRem(14),
                lineHeight: "normal",
            },
            ...commonStyles,
            "& .Mui-focused": {
                "& .MuiAutocomplete-popupIndicator": {
                    visibility: "visible",
                },
            },
            "& .MuiAutocomplete-popupIndicator": {
                visibility: props.variant === "standard" ? "hidden" : "visible",
            },
            "& .MuiInputBase-root": { backgroundColor: props.backgroundColor ?? "transparent" },
        } as SxProps<Theme>,
        container: {
            width: props.width ?? "100%",
            position: "relative",
            marginTop: props.noMargin ? 0 : theme.spacing(2),
            marginBottom: props.noMargin ? 0 : theme.spacing(1),
        } as SxProps<Theme>,
        helperText: {
            "& .MuiFormHelperText-root": {
                color: alpha(theme.palette.primary.dark, 0.6),
            },
        },
        iconsContainer: getRightIconsStyle(props) as SxProps<Theme>,
        exclamationIcon: {
            fill: theme.palette.error.main,
            width: iconSize,
            height: iconSize,
        },
        chipContainer: {
            margin: "2px",
            maxWidth: "calc(100% + 2px)",
        },
    });
};
